import { render, staticRenderFns } from "./person-form.vue?vue&type=template&id=8947db9c&"
import script from "./person-form.vue?vue&type=script&lang=js&"
export * from "./person-form.vue?vue&type=script&lang=js&"
import style0 from "./person-form.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports